import * as React from 'react';
import * as style from './InsidePage.css';
import { TPage, IPageContent } from '../../types/helper';
import { INSIDE_PAGE_CONTENT } from '../../constants/page-content';
import { Desktop, Mobile, Tablet } from '../common/responsive';
import { ViewDesktop } from './views/Desktop';
import { ViewMobile } from './views/Mobile';
import { ViewTablet } from './views/Tablet';

export interface IInsidePageProps {
  page: TPage;
}

export const InsidePage = (props: IInsidePageProps) => {
  const { page } = props;

  if (!(page in INSIDE_PAGE_CONTENT)) {
    return null;
  }

  const content: IPageContent = INSIDE_PAGE_CONTENT[page];

  return (
    <div className={style['container']}>
      <Mobile>
        <ViewMobile content={content}  />
      </Mobile>
      <Tablet>
        <ViewTablet content={content} />
      </Tablet>
      <Desktop>
        <ViewDesktop content={content} />
      </Desktop>
    </div>
  );
};
